import moment from 'moment';
import { isIOS, isMacOs, isMobile, isTablet } from 'react-device-detect';
import tinycolor from 'tinycolor2';

import { qplayerDomain, qplayerLoaderUrl, qplayerWebComponentLoaderUrl } from './config';

export const ENTERPRISE_CONFIG_ID = 'Enterprise';
export const STORY_CONFIG_ID = 'Story';
// The Story preset's accent, from the design. A preset that sets playerStyling.primaryColor wins.
export const STORY_ACCENT_COLOR = '#FF5073';
// Slides each side of the active one that keep a mounted player. Each is a full GoBrain instance,
// so 1 - three live players - keeps the neighbour warm without paying for the whole playlist.
export const STORY_SLIDE_WINDOW = 1;
export const SCENE_EDITOR_PLAYER_CONFIG_ID = '847a7a05-52c8-4495-bf26-5cae9eea2f86';
export const SCENE_EDITOR_PLAYER_ACCOUNT_ID = 'Accpy7KNHj1IUilFL5BMuNL0Q';
export const EDITOR_PLAYER_ID = 'player-for-editor';

export const SCREEN_TYPE = {
	huge: 'huge',
	big: 'big',
	medium: 'medium',
	small: 'small',
	mobile: 'mobile',
};
export const FONTS = ['Arial', 'Poppins', 'Roboto'];

export const getTime = (input) => {
	let timeArray = input.split(':');
	return {
		hours: timeArray[0],
		minutes: timeArray[1],
		seconds: timeArray.length > 2 ? timeArray[2] : '00',
		milliseconds: timeArray.length > 3 ? timeArray[3] : '000',
	};
};

export const returnAddedTime = (time, duration, format) => {
	let newTime = new Date(moment(time).add(duration, format));
	return newTime;
};

export const getTimelineStartDate = (_) => {
	//date changed to 1970 as when page is opened in one date and try to save in another date values are saved in negative numbers
	let d = new Date(0);
	d.setHours(0);
	return d;
};

export const getTimelineTimeFromTimeInput = (input) => {
	const timeInput = (input ?? '00:00:00:00').replace('.', ':');
	let time = getTime(timeInput);
	let newTime = getTimelineStartDate();
	newTime.setHours(time.hours);
	newTime.setMinutes(time.minutes);
	newTime.setSeconds(time.seconds);
	newTime.setMilliseconds(time.milliseconds.substr(0, 3));
	return newTime;
};

export const getSecondsFromTimelineTime = (time) => {
	return Number(getTimeDifferenceInSeconds(time, getTimelineStartDate()));
};

export const getTimeDifferenceInSeconds = (afterTime, beforeTime) => {
	if (!afterTime || !beforeTime) {
		return null;
	}
	return (new Date(afterTime).getTime() - new Date(beforeTime).getTime()) / 1000;
};

export const getDifferenceBetweenTwodates = (endTime, startTime) => {
	let time = new Date(endTime) - new Date(startTime);
	let seconds = moment.duration(time).seconds();
	let minutes = moment.duration(time).minutes();
	let hours = moment.duration(time).hours();
	let days = moment.duration(time).days();
	let str = '';
	if (days > 0) {
		hours = days * 24 + hours;
	}
	str = str + (hours > 9 ? hours : '0' + hours) + ':' + (minutes > 9 ? minutes : '0' + minutes) + ':' + (seconds > 9 ? seconds : '0' + seconds);
	return str;
};

export const joinClassNames = (...args) => {
	if (!args) {
		return '';
	}

	let classNames = '';
	if (args.length === 1 && typeof args[0] === 'string') {
		const classes = args[0].split(' ').filter(Boolean);
		classNames = classes.length > 0 ? classes.join(' ').trim() : '';
	} else {
		for (const arg of args) {
			if (!arg) {
				classNames = classNames;
			} else if (typeof arg === 'string') {
				classNames += ' ' + arg.trim();
			} else if (typeof arg === 'object' && arg.length) {
				for (const a of arg) {
					classNames += ' ' + joinClassNames(a);
				}
			}
		}
	}

	return classNames.trim();
};

// The aspectRatio embed param is passed through as a CSS aspect-ratio value, e.g. "16/9" or "1.7778".
// Returns width / height as a number, or undefined when the value cannot be read.
export const getAspectRatioValue = (aspectRatio) => {
	if (!aspectRatio) {
		return undefined;
	}

	const [width, height] = String(aspectRatio).split(/[/:]/).map((part) => parseFloat(part));
	if (isNaN(width) || width <= 0) {
		return undefined;
	}
	if (height === undefined) {
		return width;
	}

	return !isNaN(height) && height > 0 ? width / height : undefined;
};

export const toHHMMSS = (time, minus = false) => {
	if (!time && time !== 0) {
		return '--:--';
	} else {
		const timing = time;

		var hours = Math.floor(timing / 3600);
		var minutes = Math.floor(timing / 60) % 60;
		var seconds = Math.floor(timing % 60);

		if (hours < 10) {
			hours = '0' + hours;
		}
		if (minutes < 10) {
			minutes = '0' + minutes;
		}
		if (seconds < 10) {
			seconds = '0' + seconds;
		}

		const sign = minus ? '-' : '';
		if (hours === '00') {
			return sign + minutes + ':' + seconds;
		} else {
			return sign + hours + ':' + minutes + ':' + seconds;
		}
	}
};

export const heartAnimation = (controlBarClassName, container) => {
	var b = Math.floor(Math.random() * 100 + 1);
	var d = ['flowOne', 'flowTwo', 'flowThree'];
	var a = ['colOne', 'colTwo', 'colThree', 'colFour', 'colFive', 'colSix'];
	var c = (Math.random() * (1.6 - 1.2) + 1.2).toFixed(1);

	const heartIcon = document.createElement('div');
	heartIcon.className = 'heart-icon';
	const heart = document.createElement('div');
	heart.className = 'heart part-' + b + ' ' + a[Math.floor(Math.random() * 6)];
	heart.style.width = '15px';
	heart.style.height = '15px';
	heart.style.fontSize = Math.floor(Math.random() * (50 - 22) + 10) + 'px';
	heart.style.animation = d[Math.floor(Math.random() * 3)] + ' ' + c + 's linear';
	heart.appendChild(heartIcon);

	const heartControlBar = (container ?? document).getElementsByClassName(controlBarClassName)[0];
	if (heartControlBar) {
		heartControlBar.appendChild(heart);
	}

	const parts = (container ?? document).getElementsByClassName('part-' + b);
	if (parts && parts.length > 0) {
		for (const p of parts) {
			if (!p) {
				return;
			}
			p.style.display = 'block';
			setTimeout(() => {
				p.style.display = 'none';
				heartControlBar.removeChild(p);
			}, c * 900);
		}
	}
};

export const setAdditionalStyleSheet = ({ settings, isMediaLive, paramSharing, paramDownload, isBonnierDi = false }) => {
	if (!settings) {
		return;
	}

	if (!document.getElementById('sheetSubtitleStyling')) {
		let sheetSubtitleStyling = document.createElement('style');
		sheetSubtitleStyling.id = 'sheetSubtitleStyling';
		const subBottom = !settings?.subtitleStyling?.position?.y ? '10px' : `${settings?.subtitleStyling?.position?.y}%`;
		const isIOS183 = isIOS && (navigator.userAgent.includes('18.3') || navigator.userAgent.includes('18_3'));
		const isIOS182 = isIOS && (navigator.userAgent.includes('18.2') || navigator.userAgent.includes('18_2'));
		const additional =
			isIOS183 || isIOS182
				? `.gobrain-id-mediaplayer-container *::-webkit-media-text-track-container {
			padding: 0px !important;
			transform: translateY(20%) !important;
		}`
				: '';
		const subtitleStyling = `div[data-internal-gobrain-box-configuration-modulename='Subtitles'] {bottom: ${subBottom} !important;} ${additional}
		 div[data-internal-gobrain-box-configuration-modulename='Restrictions'] { display: none !important; }`;

		sheetSubtitleStyling.innerHTML = subtitleStyling;
		document.head.appendChild(sheetSubtitleStyling);
	}

	if (isMediaLive && !document.getElementById('sheetLivePLayer')) {
		var sheetLivePLayer = document.createElement('style');
		sheetLivePLayer.id = 'sheetLivePLayer';
		sheetLivePLayer.innerHTML =
			'.gobrain-time-position{display: none !important;} .gobrain-fn-backward{display: none !important;} .gobrain-fn-forward{display: none !important;}';
		document.head.appendChild(sheetLivePLayer);
	}

	if (!settings?.bottomControls?.enabled && !document.getElementById('sheetHideControlBar')) {
		var sheetHideControlBar = document.createElement('style');
		sheetHideControlBar.id = 'sheetHideControlBar';
		sheetHideControlBar.innerHTML = '.gobrain-id-controls-container{display: none !important;}';
		document.head.appendChild(sheetHideControlBar);
	}

	if (!settings?.bottomControls?.showRewindForwardButtons && !document.getElementById('sheetHideRewindForwardButtons')) {
		var sheetHideRewindForwardButtons = document.createElement('style');
		sheetHideRewindForwardButtons.id = 'sheetHideRewindForwardButtons';
		sheetHideRewindForwardButtons.innerHTML =
			'.gobrain-controller-backward{display: none !important;} .gobrain-controller-forward{display: none !important;}';
		document.head.appendChild(sheetHideRewindForwardButtons);
	}

	if (!settings?.bottomControls?.showTimeline && !document.getElementById('sheetHideTimeline')) {
		var sheetHideTimeline = document.createElement('style');
		sheetHideTimeline.id = 'sheetHideTimeline';
		sheetHideTimeline.innerHTML = '.gobrain-id-controls-container .gobrain-progress-wrapper{display: none !important;}';
		document.head.appendChild(sheetHideTimeline);
	}

	if (!settings?.bottomControls?.showPlaybackControls && !document.getElementById('sheetHidePlaybackControls')) {
		var sheetHidePlaybackControls = document.createElement('style');
		sheetHidePlaybackControls.id = 'sheetHidePlaybackControls';
		sheetHidePlaybackControls.innerHTML = '.gobrain-video-left{visibility: hidden !important;}';
		document.head.appendChild(sheetHidePlaybackControls);
	}

	if (!settings?.bottomControls?.showSettingsButton && !document.getElementById('sheetHideSettingsButton')) {
		var sheetHideSettingsButton = document.createElement('style');
		sheetHideSettingsButton.id = 'sheetHideSettingsButton';
		sheetHideSettingsButton.innerHTML = '.gobrain-controller-additional-settings{ display: none !important;}';
		document.head.appendChild(sheetHideSettingsButton);
	}

	if (!settings?.bottomControls?.showVideoQualitySettings && !document.getElementById('sheetHideVideoQualitySettings')) {
		var sheetHideVideoQualitySettings = document.createElement('style');
		sheetHideVideoQualitySettings.id = 'sheetHideVideoQualitySettings';
		sheetHideVideoQualitySettings.innerHTML = '.gobrain-option-quality{ display: none !important;}';
		document.head.appendChild(sheetHideVideoQualitySettings);
	}

	if (!settings?.bottomControls?.showAudioControls && !document.getElementById('sheetHideAudioControls')) {
		var sheetHideAudioControls = document.createElement('style');
		sheetHideAudioControls.id = 'sheetHideAudioControls';
		sheetHideAudioControls.innerHTML = '.gobrain-controller-volume{ display: none !important;}';
		document.head.appendChild(sheetHideAudioControls);
	}

	if (!settings?.bottomControls?.showFullscreen && !document.getElementById('sheetHideFullscreen')) {
		var sheetHideFullscreen = document.createElement('style');
		sheetHideFullscreen.id = 'sheetHideFullscreen';
		sheetHideFullscreen.innerHTML = '.custom-fullscreen-player{ display: none !important;}';
		document.head.appendChild(sheetHideFullscreen);
	}

	if (!settings?.bottomControls?.showPlayPauseButton && !document.getElementById('sheetHidePlayPauseButton')) {
		var sheetHidePlayPauseButton = document.createElement('style');
		sheetHidePlayPauseButton.id = 'sheetHidePlayPauseButton';
		sheetHidePlayPauseButton.innerHTML = '.gobrain-controller-play{ display: none !important;} .gobrain-fn-pause {display: none !important;}';
		document.head.appendChild(sheetHidePlayPauseButton);
	}

	if (!settings?.bottomControls?.showPictureInPicture && !document.getElementById('sheetHidePictureInPicture')) {
		var sheetHidePictureInPicture = document.createElement('style');
		sheetHidePictureInPicture.id = 'sheetHidePictureInPicture';
		sheetHidePictureInPicture.innerHTML = '.gobrain-tooltip-qbrick-player{display: none !important;}';
		document.head.appendChild(sheetHidePictureInPicture);
	}

	if (!settings?.bottomControls?.showLanguageSettingsButton && !document.getElementById('sheetHidePictureInPicture')) {
		var sheetHideLanguageSettingsButton = document.createElement('style');
		sheetHideLanguageSettingsButton.id = 'sheetHideLanguageSettingsButton';
		sheetHideLanguageSettingsButton.innerHTML = '.gobrain-fn-subtitles-and-audio{display: none !important;}';
		document.head.appendChild(sheetHideLanguageSettingsButton);
	}

	if (settings?.bottomControls?.alwaysVisible && !document.getElementById('sheetAlwaysVisisbleControlBar')) {
		var sheetAlwaysVisisbleControlBar = document.createElement('style');
		sheetAlwaysVisisbleControlBar.id = 'sheetAlwaysVisisbleControlBar';
		sheetAlwaysVisisbleControlBar.innerHTML = '.gobrain-controlbar-wrapper {opacity: 1 !important;}';
		document.head.appendChild(sheetAlwaysVisisbleControlBar);
	}

	if (!settings?.bottomControls?.showSubtitlesSettings && !document.getElementById('sheetHideSubtitlesSettings')) {
		var sheetHideSubtitlesSettings = document.createElement('style');
		sheetHideSubtitlesSettings.id = 'sheetHideSubtitlesSettings';
		sheetHideSubtitlesSettings.innerHTML = '.gobrain-subtitles-menu{display: none !important;}';
		document.head.appendChild(sheetHideSubtitlesSettings);
	}

	if (!settings?.bottomControls?.showAudioTracksSettings && !document.getElementById('sheetHideAudioTracksSettings')) {
		var sheetHideAudioTracksSettings = document.createElement('style');
		sheetHideAudioTracksSettings.id = 'sheetHideAudioTracksSettings';
		sheetHideAudioTracksSettings.innerHTML = '.gobrain-audio-menu{display: none !important;}';
		document.head.appendChild(sheetHideAudioTracksSettings);
	}

	if (settings?.topControls && !settings?.topControls?.enabled && !document.getElementById('sheetHideTopControls')) {
		var sheetHideTopControls = document.createElement('style');
		sheetHideTopControls.id = 'sheetHideTopControls';
		sheetHideTopControls.innerHTML = '.gobrain-topcontrolbar-wrapper{display: none !important;}';
		document.head.appendChild(sheetHideTopControls);
	}

	if (settings?.topControls && !settings?.topControls?.showTitle && !document.getElementById('sheetHideTopControlsTitle')) {
		var sheetHideTopControlsTitle = document.createElement('style');
		sheetHideTopControlsTitle.id = 'sheetHideTopControlsTitle';
		sheetHideTopControlsTitle.innerHTML = '.gobrain-playback-title{display: none !important;}';
		document.head.appendChild(sheetHideTopControlsTitle);
	}

	if (settings?.topControls && !settings?.topControls?.showAccountName && !document.getElementById('sheetHideTopControlsAccountName')) {
		var sheetHideTopControlsAccountName = document.createElement('style');
		sheetHideTopControlsAccountName.id = 'sheetHideTopControlsAccountName';
		sheetHideTopControlsAccountName.innerHTML = '.gobrain-playlist-title{display: none !important;}';
		document.head.appendChild(sheetHideTopControlsAccountName);
	}

	if (!document.getElementById('sheetHideTopCotrolsSocialSharing')) {
		var sheetHideTopCotrolsSocialSharing = document.createElement('style');
		if (paramSharing === null) {
			if (settings.topControls && !settings?.topControls?.showSocialSharing) {
				sheetHideTopCotrolsSocialSharing.id = 'sheetHideTopCotrolsSocialSharing';
				sheetHideTopCotrolsSocialSharing.innerHTML = '.gobrain-fn-sharing{display: none !important;}';
				document.head.appendChild(sheetHideTopCotrolsSocialSharing);
			}
		} else {
			if (paramSharing === 'false') {
				sheetHideTopCotrolsSocialSharing.id = 'sheetHideTopCotrolsSocialSharing';
				sheetHideTopCotrolsSocialSharing.innerHTML = '.gobrain-fn-sharing{display: none !important;}';
				document.head.appendChild(sheetHideTopCotrolsSocialSharing);
			}
		}
	}

	if (settings?.topControls && settings?.topControls?.alwaysVisible && !document.getElementById('sheetAlwaysVisibleTopControls')) {
		var sheetAlwaysVisibleTopControls = document.createElement('style');
		sheetAlwaysVisibleTopControls.id = 'sheetAlwaysVisibleTopControls';
		sheetAlwaysVisibleTopControls.innerHTML = '.gobrain-topcontrolbar-wrapper{opacity: 1 !important;}';
		document.head.appendChild(sheetAlwaysVisibleTopControls);
	}

	if (!document.getElementById('sheetHideTopControlsDownload')) {
		var sheetHideTopControlsDownload = document.createElement('style');
		if (paramDownload === null) {
			if (settings?.topControls && !settings.topControls?.showDownloadButton) {
				sheetHideTopControlsDownload.id = 'sheetHideTopControlsDownload';
				sheetHideTopControlsDownload.innerHTML = '.gobrain-fn-download-video{display: none !important;}';
				document.head.appendChild(sheetHideTopControlsDownload);
			}
		} else {
			if (paramDownload === 'false') {
				sheetHideTopControlsDownload.id = 'sheetHideTopControlsDownload';
				sheetHideTopControlsDownload.innerHTML = '.gobrain-fn-download-video{display: none !important;}';
				document.head.appendChild(sheetHideTopControlsDownload);
			}
		}
	}

	// Embedded on a customer's site via <qplayer-embed> (not our own page, whose body has .qplayer-app-body):
	// inherit the host page's font, unless it's Bonnier DI or a custom font file is configured.
	const isEmbeddedOnCustomerSite = !document.body.classList.contains('qplayer-app-body');
	const hasCustomFontFile = !!(settings?.playerStyling?.useCustomFont && settings?.playerStyling?.playerCustomFontUrl);
	const inheritHostFont = isEmbeddedOnCustomerSite && !isBonnierDi && !hasCustomFontFile && (settings.playerStyling.playerFont === '' || settings.playerStyling.playerFont === "Default");

	if ((inheritHostFont || (settings?.playerStyling && settings?.playerStyling?.playerFont)) && !document.getElementById('sheetPlayerFontPlayerStyling')) {
		var sheetPlayerFontPlayerStyling = document.createElement('style');
		sheetPlayerFontPlayerStyling.id = 'sheetPlayerFontPlayerStyling';
		let fontStyling = '';

		let fontName = '';
		let subtitleLineHeight = '1.25';
		if (isBonnierDi) {
			const boldFont = `.qplayer-bold-font{font-family: 'BentonSansDI Bold', sans-serif !important; font-weight: 700;}`;
			fontStyling = `qplayer-embed, qplayer-embed *, qplayer-modal-embed, qplayer-modal-embed *, .qplayer-reels-host, .qplayer-reels-host *, qplayer-embed.qplayer-modal-player-container *, .qplayer__setting-menu *, .qplayer-dialog *{font-family: 'BentonSansDI Regular', sans-serif;}${boldFont}
			qplayer-embed .MuiInputBase-input, qplayer-modal-embed .MuiInputBase-input, qplayer-embed .MuiFormLabel-root, qplayer-embed .MuiTypography-root, qplayer-modal-embed .MuiFormLabel-root, qplayer-modal-embed .MuiTypography-root, qplayer-embed .MuiInputBase-root {font-family: 'BentonSansDI Regular', sans-serif !important;}`;
		} else if (inheritHostFont) {
			fontStyling = `qplayer-embed, qplayer-embed *, qplayer-modal-embed, qplayer-modal-embed *, .qplayer-reels-host, .qplayer-reels-host *, qplayer-embed.qplayer-modal-player-container *, .qplayer__setting-menu *, .qplayer-dialog *{font-family: inherit;} qplayer-embed .MuiInputBase-input, qplayer-modal-embed .MuiInputBase-input, qplayer-embed .MuiFormLabel-root, qplayer-embed .MuiTypography-root, qplayer-modal-embed .MuiFormLabel-root, qplayer-modal-embed .MuiTypography-root, qplayer-embed .MuiInputBase-root {font-family: inherit !important;}`;
		} else if (settings.playerStyling.useCustomFont) {
			subtitleLineHeight = fontName.includes('Poppins') || fontName.includes('Open Sans') ? '1.7em' : subtitleLineHeight;
			const customFontUrl = settings.playerStyling.playerCustomFontUrl ?? '';
			const customFontName = settings.playerStyling.playerCustomFontName ?? settings.playerStyling.playerCustomFontName?.playerCustomFontName ?? "'Poppins', sans-serif";
			const fontFileMatch = customFontUrl.match(/\.(ttf|otf|woff2?|eot)(\?.*)?$/i);
			if (fontFileMatch) {
				const formats = { ttf: 'truetype', otf: 'opentype', woff: 'woff', woff2: 'woff2', eot: 'embedded-opentype' };
				const format = formats[fontFileMatch[1].toLowerCase()];
				fontStyling += `@font-face{font-family: ${customFontName}; src: url('${customFontUrl}') format('${format}');}`;
			} else if (customFontUrl) {
				fontStyling += `@import url('${customFontUrl}');`;
			}
			fontStyling += `qplayer-embed, qplayer-embed *, qplayer-modal-embed, qplayer-modal-embed *, .qplayer-reels-host, .qplayer-reels-host *, qplayer-embed.qplayer-modal-player-container *, .qplayer__setting-menu *, .qplayer-dialog *{font-family: ${customFontName};} qplayer-embed .MuiInputBase-input, qplayer-modal-embed .MuiInputBase-input, qplayer-embed .MuiFormLabel-root, qplayer-embed .MuiTypography-root, qplayer-modal-embed .MuiFormLabel-root, qplayer-modal-embed .MuiTypography-root, qplayer-embed .MuiInputBase-root {font-family: ${customFontName} !important;}`;
		} else {
			fontName = settings.playerStyling.playerFont !== '' && settings.playerStyling.playerFont !== 'Default' ? settings.playerStyling.playerFont : 'Poppins';
			let semiBoldFont = '';
			let lightFont = "";
			if (FONTS.includes(fontName)) {
				fontName += ', sans-serif';
			}
			if (fontName === 'Open Sans') {
				fontName = `'Open Sans Regular', sans-serif`;
				semiBoldFont = `.qplayer-semibold-font{font-family: 'Open Sans Semibold', sans-serif !important; font-weight: normal !important;}`;
				lightFont = `.qplayer-light-font{font-family: 'Open Sans Light' !important; font-weight: normal !important;}`;
			}
			fontStyling = `qplayer-embed, qplayer-embed *, qplayer-modal-embed, qplayer-modal-embed *, .qplayer-reels-host, .qplayer-reels-host *, qplayer-embed.qplayer-modal-player-container *, .qplayer__setting-menu *, .qplayer-dialog *{font-family: ${fontName};}qplayer-embed .MuiInputBase-input, qplayer-modal-embed .MuiInputBase-input, qplayer-embed .MuiFormLabel-root, qplayer-embed .MuiTypography-root, qplayer-modal-embed .MuiFormLabel-root, qplayer-modal-embed .MuiTypography-root, qplayer-embed .MuiInputBase-root {font-family: ${fontName} !important;}${lightFont}${semiBoldFont}`;
			subtitleLineHeight = fontName.includes('Poppins') ? '1.7em' : subtitleLineHeight;
		}
		const subtitleTextStyle = `.gobrain-id-subtitles-container .subtitle-text span{line-height:${subtitleLineHeight} !important;} .qplayer-app--ads-playing .gobrain-id-subtitles-container { display: none !important; }`;

		sheetPlayerFontPlayerStyling.innerHTML = fontStyling + subtitleTextStyle;
		document.head.appendChild(sheetPlayerFontPlayerStyling);
	}

	if (!document.getElementById('sheetBackgroundColorPlayerStyling')) {
		const color = settings?.playerStyling?.playerBackgroundColor ?? '#000000';
		const opacity = Number(settings?.playerStyling?.playerBackgroundOpacity ?? 100);
		const rgbaWithOpa = { ...tinycolor(color).toRgb(), a: opacity / 100 };

		const sheetBackgroundColorPlayerStyling = document.createElement('style');
		sheetBackgroundColorPlayerStyling.id = 'sheetBackgroundColorPlayerStyling';
		sheetBackgroundColorPlayerStyling.innerHTML = `.gobrain-view-layer[class$="-layer-0"], .playerWindow{background-color: ${tinycolor(rgbaWithOpa).toRgbString()} !important;}`;
		document.head.appendChild(sheetBackgroundColorPlayerStyling);
	}

	if (settings?.playerStyling && settings?.playerStyling?.primaryColor) {
		const color = settings?.playerStyling?.primaryColor ?? '#126cfc';
		const opacity = Number(settings?.playerStyling?.primaryOpacity ?? 100);
		const rgbaWithOpa = { ...tinycolor(color).toRgb(), a: opacity / 100 };

		if (!document.getElementById('sheetHoverColorPlayerStyling')) {
			const sheetHoverColorPlayerStyling = document.createElement('style');
			sheetHoverColorPlayerStyling.id = 'sheetHoverColorPlayerStyling';
			sheetHoverColorPlayerStyling.innerHTML = `.gobrain-hovering{background-color: ${tinycolor(rgbaWithOpa).toRgbString()} !important;}
														.gobrain-id-controls-container .gobrain-window .gobrain-additional-settings-main-menu{background-color: ${tinycolor(
				rgbaWithOpa
			).toRgbString()} !important;}
														.gobrain-id-controls-container .gobrain-option-row[aria-checked='true']{background-color: ${tinycolor(rgbaWithOpa).toRgbString()} !important;}
														.gobrain-id-controls-container .gobrain-option-row:hover:not(.gobrain-window-header){background-color: ${tinycolor(
				rgbaWithOpa
			).toRgbString()} !important;}
														.gobrain-reset-styling input[type="radio"]:checked+.radio-label:before{box-shadow: inset 0 0 0 2.5px ${tinycolor(
				rgbaWithOpa
			).toRgbString()} !important;}`;
			document.head.appendChild(sheetHoverColorPlayerStyling);
		}
	}
};

// The preset's rounded corners (Player styling) as a CSS border-radius value, or '' for none.
// It is any border-radius value ("16px", "10px 20px", "50% / 10%"); older presets hold a bare number, read as px.
// A value the browser does not accept, or one that is all zeros, counts as none.
export const getPlayerBorderRadius = (settings) => {
	const value = String(settings?.playerStyling?.playerBorderRadius ?? '').trim();
	const borderRadius = /^\d+(\.\d+)?$/.test(value) ? `${value}px` : value;
	return /[1-9]/.test(borderRadius) && CSS.supports('border-radius', borderRadius) ? borderRadius : '';
};

export const enterFullscreen = (currentPlayerId, callback) => {
	if (isIOS || (isMacOs && 'ontouchend' in document)) {
		const widget = window.GoBrain.widgets()[currentPlayerId];
		widget?.fullscreen && widget.fullscreen();
	} else {
		let elem = document.getElementById('main-container');
		if (!elem) {
			elem = document.documentElement;
		}
		elem?.requestFullscreen?.();
		callback?.();
	}
};

export const exitFullscreen = (currentPlayerId, callback) => {
	if (isIOS || (isMacOs && 'ontouchend' in document)) {
		const widget = window.GoBrain.widgets()[currentPlayerId];
		widget?.fullscreen(false);
	} else {
		document.exitFullscreen?.();
		callback?.();
	}
};
export const SHARE_ORIGIN_ITEMS = {
	directLink: 'directLink',
	siteEmbed: 'siteEmbed',
	custom: 'custom',
};
/**
 * A configured share URL may be a template, substituted with whatever is playing - which is what
 * makes per-item sharing possible: https://borsen.dk/reel/{playlistId}/{mediaId}
 */
export const resolveShareUrlTokens = (url, { mediaDetails, paramConfigs }) => {
	if (!url || url.indexOf('{') === -1) {
		return url;
	}
	return url
		.replace(/\{mediaId\}/g, mediaDetails?.id ?? '')
		.replace(/\{playlistId\}/g, paramConfigs?.playlistId ?? '');
};

export const getPreviewLink = ({ configs, accountId, type, paramConfigs, mediaDetails, time, embedShareSettings }) => {
	if (!configs) {
		return 'No settings found';
	}
	if (!mediaDetails) {
		return 'No media found';
	}

	let timeParam = '';
	if (time) {
		timeParam = `${type === 'video' ? "" : `id=${mediaDetails.id}&`}in=${time}`;
	}

	const shareSettings = configs.topControls?.shareSettings ?? {};
	if (embedShareSettings?.shareUrl) {
		// Identity for any URL without a brace in it, so every existing share link is byte-identical.
		return `${resolveShareUrlTokens(embedShareSettings.shareUrl, { mediaDetails, paramConfigs })}${timeParam ? '?' + timeParam : ''}`;
	}

	if (shareSettings.urlOrigin && shareSettings.urlOrigin !== SHARE_ORIGIN_ITEMS.directLink) {
		const urlOrigin = shareSettings.urlOrigin === SHARE_ORIGIN_ITEMS.siteEmbed ? embedShareSettings.origin : shareSettings.customUrl;
		// The preset's own custom URL gets the same substitution, so both ways of declaring one match.
		return `${resolveShareUrlTokens(urlOrigin, { mediaDetails, paramConfigs }) ?? qplayerDomain}${timeParam ? '?' + timeParam : ''}`;
	}

	const { replay, autostart, muteAtStart, showDownloadButton, showSocialSharing, language } = configs;
	const mediaType = type === 'video' ? 'mediaId' : type === 'scenario' ? 'scenarioId' : 'playlistId';
	const muteAtStartAttr = paramConfigs.mute && muteAtStart !== paramConfigs.mute ? `&mute=${paramConfigs.mute}` : '';
	const autostartAttr = paramConfigs.autoplay && autostart !== paramConfigs.autoplay ? `&autoplay=${paramConfigs.autoplay}` : '';
	const showSocialSharingAttr = paramConfigs.sharing && showSocialSharing !== paramConfigs.sharing ? `&sharing=${paramConfigs.sharing}` : '';
	const replayAttr = paramConfigs.repeat && replay !== paramConfigs.repeat ? `&repeat=${paramConfigs.repeat}` : '';
	const showDownloadButtonAttr =
		paramConfigs.downloadMedia && showDownloadButton !== paramConfigs.downloadMedia ? `&downloadMedia=${paramConfigs.downloadMedia}` : '';
	const languageAttr = language !== paramConfigs?.language && language ? `&language="${language}"` : '';

	return `${qplayerDomain}?accountId=${accountId}&${mediaType}=${mediaDetails.id}&configId=${configs.id}${autostartAttr}${showSocialSharingAttr}${showDownloadButtonAttr}${replayAttr}${muteAtStartAttr}${languageAttr}${timeParam ? '&' + timeParam : ''}`;
};

export const getIframeEmbedCode = ({ configs, accountId, type, mediaDetails, paramConfigs, time }) => {
	const { replay, autostart, muteAtStart, showDownloadButton, showSocialSharing, language } = configs;
	if (!configs) {
		return 'No player configs found';
	}
	if (!mediaDetails) {
		return 'No media found';
	}

	let timeParam = '';
	if (time) {
		timeParam = `&id=${mediaDetails.id}&in=${time}`;
	}

	const title = mediaDetails?.title;
	const mediaType = type === 'video' ? 'mediaId' : type === 'scenario' ? 'scenarioId' : 'playlistId';
	const muteAtStartAttr = paramConfigs.mute && muteAtStart !== paramConfigs.mute ? `&mute=${paramConfigs.mute}` : '';
	const autostartAttr = paramConfigs.autoplay && autostart !== paramConfigs.autoplay ? `&autoplay=${paramConfigs.autoplay}` : '';
	const showSocialSharingAttr = paramConfigs.sharing && showSocialSharing !== paramConfigs.sharing ? `&sharing=${paramConfigs.sharing}` : '';
	const replayAttr = paramConfigs.repeat && replay !== paramConfigs.repeat ? `&repeat=${paramConfigs.repeat}` : '';
	const showDownloadButtonAttr =
		paramConfigs.downloadMedia && showDownloadButton !== paramConfigs.downloadMedia ? `&downloadMedia=${paramConfigs.downloadMedia}` : '';
	const languageAttr = language !== paramConfigs?.language && language ? `&language="${language}"` : '';
	const allow = autostartAttr && muteAtStart ? 'autoplay; ' : '';

	return `<iframe height="360" width="640" title="${title}" src="${qplayerDomain}?accountId=${accountId}&${mediaType}=${mediaDetails.id}&configId=${configs.id}${autostartAttr}${showSocialSharingAttr}${showDownloadButtonAttr}${replayAttr}${muteAtStartAttr}${languageAttr}${timeParam}" allow="${allow}picture-in-picture; clipboard-write; web-share" allowFullScreen frameborder="0" border="0"></iframe>`;
};

export const getDivEmbedCode = ({ configs, accountId, type, mediaDetails, paramConfigs, time }) => {
	const { replay, autostart, muteAtStart, showDownloadButton, showSocialSharing, showOpenInNewWindow, language } = configs;

	const title = mediaDetails?.title;
	const muteAtStartAttr = paramConfigs && muteAtStart !== paramConfigs.muteAtStart ? `data-qplayer-mute="${muteAtStart}" ` : '';
	const autostartAttr = paramConfigs && autostart !== paramConfigs.autostart ? `data-qplayer-autoplay="${autostart}" ` : '';
	const showSocialSharingAttr =
		paramConfigs && showSocialSharing !== paramConfigs.showSocialSharing ? `data-qplayer-sharing="${showSocialSharing}" ` : '';
	const replayAttr = paramConfigs && replay !== paramConfigs.replay ? `data-qplayer-repeat="${replay}" ` : '';
	const showDownloadButtonAttr =
		paramConfigs && showDownloadButton !== paramConfigs.showDownloadButton ? `data-qplayer-download="${showDownloadButton}" ` : '';
	const showOpenInNewWindowAttr =
		paramConfigs && showOpenInNewWindow !== paramConfigs.showOpenInNewWindow ? `data-qplayer-openInNewWindow="${showOpenInNewWindow}" ` : '';
	const mediaType = type === 'video' ? 'media' : type === 'scenario' ? 'scenario' : 'playlist';
	const languageAttr = paramConfigs && language !== paramConfigs.language && language ? `data-qplayer-language="${language}"` : '';
	const timeAttr = time ? `data-qplayer-startAt="${time}"` : '';

	const isDevEnv = process.env.NODE_ENV !== 'production';

	// video ratio 16:9, set padding-bottom 56.25%; video ratio 1:1, set padding-bottom 100%
	return (
		`<div style="position:relative;padding-bottom:56.25%;">` +
		`<div style="position:absolute;top:0;left:0;" ` +
		`title="${title}" ` +
		`data-qplayer-account-id="${accountId}" ` +
		`data-qplayer-${mediaType}-id="${mediaDetails.id}" ` +
		`data-qplayer-preset-id="${configs.id}" ` +
		`${isDevEnv ? 'data-qplayer-test="true" ' : ''}` +
		`${timeAttr}` +
		`${languageAttr}` +
		`${autostartAttr}` +
		`${showSocialSharingAttr}` +
		`${muteAtStartAttr}` +
		`${replayAttr}` +
		`${showDownloadButtonAttr}` +
		`${showOpenInNewWindowAttr}></div>\n` +
		`<script id="qplayer" src="${qplayerLoaderUrl}"></script>` +
		`</div>`
	);
};

export const getQplayerEmbedCode = ({ configs, accountId, type, mediaDetails, paramConfigs, time, embedType }) => {
	if (embedType === 'iframe') {
		return getIframeEmbedCode({ configs, accountId, type, mediaDetails, paramConfigs, time });
	}

	const { replay, autostart, muteAtStart, showDownloadButton, showSocialSharing, showOpenInNewWindow, language } = configs;

	const title = mediaDetails?.title;
	const muteAtStartAttr = paramConfigs && muteAtStart !== paramConfigs.muteAtStart ? `data-qplayer-mute="${muteAtStart}" ` : '';
	const autostartAttr = paramConfigs && autostart !== paramConfigs.autostart ? `data-qplayer-autoplay="${autostart}" ` : '';
	const showSocialSharingAttr =
		paramConfigs && showSocialSharing !== paramConfigs.showSocialSharing ? `data-qplayer-sharing="${showSocialSharing}" ` : '';
	const replayAttr = paramConfigs && replay !== paramConfigs.replay ? `data-qplayer-repeat="${replay}" ` : '';
	const showDownloadButtonAttr =
		paramConfigs && showDownloadButton !== paramConfigs.showDownloadButton ? `data-qplayer-download="${showDownloadButton}" ` : '';
	const showOpenInNewWindowAttr =
		paramConfigs && showOpenInNewWindow !== paramConfigs.showOpenInNewWindow ? `data-qplayer-openInNewWindow="${showOpenInNewWindow}" ` : '';
	const mediaType = type === 'video' ? 'media' : type === 'scenario' ? 'scenario' : 'playlist';
	const languageAttr = paramConfigs && language !== paramConfigs.language && language ? `data-qplayer-language="${language}"` : '';
	const timeAttr = time ? `data-qplayer-start-at="${time}"` : '';

	const isDevEnv = process.env.NODE_ENV !== 'production';

	// video ratio 16:9, set padding-bottom 56.25%; video ratio 1:1, set padding-bottom 100%
	return (
		`<qplayer-embed style="position:absolute;top:0;left:0;" ` +
		`title="${title}" ` +
		`data-qplayer-account-id="${accountId}" ` +
		`data-qplayer-${mediaType}-id="${mediaDetails.id}" ` +
		`data-qplayer-preset-id="${configs.id}" ` +
		`${isDevEnv ? 'data-qplayer-dev="true" ' : ''}` +
		`${timeAttr}` +
		`${languageAttr}` +
		`${autostartAttr}` +
		`${showSocialSharingAttr}` +
		`${muteAtStartAttr}` +
		`${replayAttr}` +
		`${showDownloadButtonAttr}` +
		`${showOpenInNewWindowAttr}></qplayer-embed>\n` +
		`<script src="${qplayerWebComponentLoaderUrl}"></script>`
	);
};

export const formatTime = (time) => {
	if (!time || isNaN(+time) || !isFinite(+time) || 0.5 > Math.abs(time)) {
		return '00:00:00';
	}

	var hours = Math.floor(time / 3600),
		minutes = Math.floor(time / 60) % 60,
		seconds = Math.floor(time % 60);

	var formattedTime = '';

	formattedTime += (hours < 10 ? '0' : '') + hours + ':';

	return formattedTime + (minutes < 10 ? '0' : '') + minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
};

export const parseTime = (value) => {
	var datetime = new Date('1970-01-01T' + value + 'Z');
	var hours = datetime.getUTCHours();
	var minutes = datetime.getUTCMinutes();
	var seconds = datetime.getUTCSeconds();

	return hours * 3600 + minutes * 60 + seconds;
};

export const stringFormat = (pattern, options) => {
	if (!pattern) {
		return null;
	}

	var _args = Object.keys(options);
	for (var i = 1; i < _args.length; i++) {
		pattern = pattern.replace(new RegExp('\\{' + (i - 1) + '\\}', 'g'), _args[i]);
	}

	return pattern;
};

export const generateUUID = () => {
	let d = new Date().getTime();
	if (Date.now) {
		d = Date.now();
	}

	return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
		let r = (d + Math.random() * 16) % 16 | 0;
		d = Math.floor(d / 16);
		return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16);
	});
};

export const getTranslateKey = (originKey) => {
	let translationKey = originKey;
	if (originKey.includes('-cc') || originKey.includes('-ad')) {
		translationKey = originKey.split('-')[0];
	}
	return translationKey;
};

export const checkPreCoverActive = (coverTracks) => {
	if (!coverTracks) {
		return false;
	}

	if (coverTracks.length && coverTracks[0] && coverTracks[0].sequences && coverTracks[0].sequences.length) {
		const preCover =
			coverTracks[0].sequences.filter((sequence) => {
				return 0 === sequence.start && (undefined === sequence.end || 0 < sequence.end);
			})[0] || null;

		return !!preCover;
	}

	return false;
};

export const checkPostCoverActive = (coverTracks, liveManager) => {
	if (!coverTracks || !liveManager) {
		return false;
	}

	const { start, stop } = liveManager;

	const dateNowUtcTimestamp = Date.now();
	const eventStartDate = new Date(start);

	if (stop) {
		const eventEndDate = new Date(stop);
		const eventEndDateUtcTimestamp = eventEndDate.getTime();

		if (dateNowUtcTimestamp > eventEndDateUtcTimestamp) {
			return true; // means there is postcover - default or custom
		}
	}

	if (coverTracks.length && coverTracks[0] && coverTracks[0].sequences && coverTracks[0].sequences.length) {
		const postCover =
			coverTracks[0].sequences.filter((sequence) => {
				return 0 < sequence.start && undefined === sequence.end;
			})[0] || null;

		if (postCover) {
			const eventStartDateUtcTimestamp = eventStartDate.getTime();
			const finishDateUtcTimestamp = eventStartDateUtcTimestamp + postCover.start * 1000;

			if (dateNowUtcTimestamp > finishDateUtcTimestamp) {
				return !!postCover;
			}
		}
	}

	return false;
};

export const convertSecondsToInputTime = (time) => {
	if (isNaN(+time) || !isFinite(+time) || 0.5 > Math.abs(time)) {
		return '00:00:00';
	}

	const hours = Math.floor(time / 3600),
		minutes = Math.floor(time / 60) % 60,
		seconds = Math.floor(time % 60);

	let formattedTime = '';
	formattedTime += (hours < 10 ? '0' : '') + hours + ':';

	return formattedTime + (minutes < 10 ? '0' : '') + minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
};

export const formatInputTime = (input) => {
	let timeArray = input.split(':');
	if (timeArray.length === 3) {
		return input;
	}
	if (timeArray.length === 2) {
		return `00:${timeArray[0]}:${timeArray[1]}`;
	}
	return '00:00:00';
};

export const convertInputTimeToSeconds = (value) => {
	if (!isNaN(+value)) {
		return value;
	}

	const dateTime = new Date('1970-01-01T' + formatInputTime((value ?? '00:00:00').replace('.', ':')) + 'Z');
	const hours = dateTime.getUTCHours();
	const minutes = dateTime.getUTCMinutes();
	const seconds = dateTime.getUTCSeconds();

	return hours * 3600 + minutes * 60 + seconds;
};

export const isAllowAutoPlay = ({ configParams, settings }) => {
	const autoplayFromParam = !configParams?.autoplay ? (settings?.playbackOptions?.autostart ? true : false) : configParams?.autoplay === 'true';
	const volume = !configParams?.mute ? (settings?.playbackOptions?.muteAtStart ? 0 : 0.5) : configParams?.mute === 'true' ? 0 : 0.5;

	return autoplayFromParam && volume === 0;
};

export const isUsedOnMobile = (configParams) => {
	if (configParams?.mobileDevice) {
		return configParams?.mobileDevice === 'true';
	}

	return isMobile && !isTablet;
};

export const isTouchable = () => {
	return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0 || isMobile;
};

export const getSubtitleFontSizeInPixelBasedOnScreenSize = (isMobile, playerSize) => {
	if (isMobile || playerSize <= 430) {
		return 0.875;
	} else if (playerSize <= 600) {
		return 0.875;
	} else if (playerSize <= 768) {
		return 1;
	} else if (playerSize <= 1280) {
		return 1.5;
	} else {
		return 2.5;
	}
};

export const focusOnFirstElement = () => {
	setTimeout(() => {
		let currentActiveElement = document.querySelector('.closeable-by-tab');

		if (currentActiveElement) {
			if (currentActiveElement.querySelector('.menu-item--hovered[tabindex="0"]')) {
				currentActiveElement.querySelector('.menu-item--hovered[tabindex="0"]')?.focus();
			} else {
				currentActiveElement.querySelector('li[tabindex="0"], button[tabindex="0"]')?.focus();
			}
		}
	}, 50);
};

export const getParentElementByClassName = (element, className) => {
	let parent = element;
	while (parent) {
		if (parent.classList && parent.classList.contains(className)) {
			return parent;
		}
		parent = parent.parentElement;
	}
	return null;
};

export const getConfigParams = ({ props, queryParams }) => {
	const configParams = {};
	configParams.accountId = props.qplayerAccountId || queryParams?.accountId || '';
	configParams.mediaId = props.qplayerMediaId || queryParams?.mediaId || '';
	configParams.scenarioId = props.qplayerScenarioId || queryParams?.scenarioId || '';
	configParams.sceneId = props.qplayerSceneId || queryParams?.sceneId || '';
	configParams.playlistId = props.qplayerPlaylistId || queryParams?.playlistId || '';
	configParams.configId = props.qplayerPresetId || queryParams?.configId || ENTERPRISE_CONFIG_ID;
	configParams.presetUrl = props.qplayerPreset || queryParams?.preset || '';
	configParams.language = props.qplayerLanguage || queryParams?.language || '';
	configParams.inline = props.qplayerInline || queryParams?.inline || '';
	configParams.qplayerPreview = props.qplayerPreview || queryParams?.preview || '';
	configParams.sharing = props.qplayerSharing || queryParams?.sharing || '';
	configParams.autoplay = props.qplayerAutoplay || queryParams?.autoplay || '';
	configParams.mute = props.qplayerMute || queryParams?.mute || '';
	configParams.repeat = props.qplayerRepeat || queryParams?.repeat || '';
	configParams.downloadMedia = props.qplayerDownload || queryParams?.downloadMedia || '';
	configParams.openInNewWindow = props.qplayerOpenInNewWindow || queryParams?.openInNewWindow || '';
	configParams.thumbnailMediaId = props.qplayerThumbnailMediaId || queryParams?.thumbnailMediaId || '';
	configParams.ignoreAnalytics = props.qplayerAnalytics ? (props.qplayerAnalytics === "off" ? "true" : "false") : queryParams?.ignoreAnalytics || '';
	configParams.ignoreChatCookies = props.qplayerChatData ? (props.qplayerChatData === "off" ? "true" : "false") : queryParams?.ignoreChatData || '';
	configParams.analyticsCookies = props.analyticsCookies ? (props.analyticsCookies === "on" ? "true" : "false") : queryParams?.analyticsCookies || '';
	configParams.subtitlesAuto = props.qplayerSubtitlesAuto ? (props.qplayerSubtitlesAuto === "on" ? "true" : "false") : queryParams?.subtitlesAuto || '';
	configParams.initPosition = props.qplayerPlaylistInitPosition || queryParams?.initPosition || '';
	// Preferred over initPosition for deep links: a media id survives editorial reordering of the
	// playlist, an index does not.
	configParams.initMediaId = props.qplayerPlaylistInitMediaId || queryParams?.initMediaId || '';
	// Opts a story playlist into the reels feed. Without it, a story playlist is unchanged.
	configParams.reels = props.qplayerReels || queryParams?.reels || '';
	// Story feed only: play the preset's ad tag as a pre-roll on every Nth slide. 0/empty = off.
	configParams.storyAdInterval = props.qplayerStoryAdInterval || queryParams?.storyAdInterval || '';
	// Overrides the preset's advertisementServer, so a tag can be swapped per embed for testing.
	configParams.storyAdTag = props.qplayerStoryAdTag || queryParams?.storyAdTag || '';
	// Seconds of an ad slot the viewer has to watch before a skip is offered. Only applies where
	// the creative itself is not skippable - a VAST skipoffset always wins, since that is IMA's.
	configParams.storyAdSkipAfter = props.qplayerStoryAdSkipAfter || queryParams?.storyAdSkipAfter || '';
	configParams.uniqueFrame = props.qplayerUniqueFrame || queryParams?.uniqueFrame || '';
	configParams.mobileDevice = props.qplayerMobileDevice || queryParams?.mobileDevice || '';
	configParams.fromQplayerWidget = props.qplayerFromQplayerWidget || queryParams?.fromQplayerWidget || '';
	configParams.hidePlayButton = props.qplayerHidePlayButton || queryParams?.hidePlayButton || '';
	configParams.qplayerId = props.qplayerId || queryParams?.qplayerId || '';
	configParams.id = queryParams?.id;
	configParams.startAt = (props.qplayerStartAt ?? props.qplayerStartat) || queryParams?.in;
	configParams.useLoader = queryParams?.useLoader;
	configParams.fromSceneEditor = queryParams?.fromSceneEditor;
	configParams.topRightSpace = props.qplayerTopRightSpace === "true" || queryParams?.topRightSpace === "true" || false;

	configParams.shareUrl = props.qplayerShareUrl || props.qplayerShareurl;
	configParams.thumbnailWidth = props.qplayerThumbnailWidth;
	configParams.thumbnailHeight = props.qplayerThumbnailHeight;
	configParams.token = props.qplayerToken;
	configParams.customButton = props.qplayerCustomButton;
	configParams.dev = props.qplayerDev;
	configParams.beta = props.qplayerBeta;
	configParams.alpha = props.qplayerAlpha;
	configParams.aspectRatio = props.qplayerAspectRatio || queryParams?.aspectRatio || '';
	configParams.autoSizing = (props.qplayerAutoSizing || queryParams?.autoSizing) === undefined ? undefined : (props.qplayerAutoSizing || queryParams?.autoSizing) === 'true';
	configParams.isModalInstance = props.qplayerModalInstance === 'true' || props?.container?.classList?.contains('qplayer-modal-player-container');
	configParams.privateAPI = props.qplayerPrivateAPI || queryParams?.privateAPI || '';
	configParams.noControls = props.qplayerNoControls || queryParams?.noControls || '';

	// Form
	configParams.eventLink = props.qplayerEventLink || queryParams?.eventLink || '';
	configParams.formToken = props.qplayerFormToken || queryParams?.formToken || '';
	configParams.formPolicyUrl = props.qplayerFormPolicyUrl;
	configParams.formTitle = props.qplayerFormTitle;
	configParams.formDescription = props.qplayerFormDescription;
	configParams.formCoverUrl = props.qplayerFormCoverUrl;
	configParams.formPrimaryColor = props.qplayerFormPrimaryColor;
	configParams.mediaTitle = props.qplayerMediaTitle;
	configParams.mediaDescription = props.qplayerMediaDescription;
	configParams.isBonnierDi = props.qplayerBonnierDi === "true" || false;
	configParams.centerPlayPause = props.qplayerCenterPlayPause;
	configParams.qplayerFiles = JSON.parse(props.qplayerFiles || queryParams?.qplayerFiles || '[]');

	configParams.container = props.container;
	configParams.containerKey = props.containerKey || props.qplayerFormPolicyUrl;
	return configParams;
}

export const getEmbedShareSettings = ({ configParams, messageData }) => {
	const embedShareSettings = {
		...messageData,
		shareUrl: messageData.shareUrl || configParams.shareUrl || '',
		origin: messageData.origin || window.location.href || window.location.origin,
		screenHeight: messageData.screenHeight || window.screen.height || window.innerHeight,
		screenWidth: messageData.screenWidth || window.screen.width || window.innerWidth,
		isModal: messageData.isModal || false,
	};
	return embedShareSettings;
}

export const loadScript = ({ src, id, onload, onerror }) => {
	const existingScriptLink = document.querySelector('script[src="' + src + '"]');
	if (existingScriptLink) {
		// If script already loaded and ready, call immediately
		if (existingScriptLink.hasAttribute('data-loaded')) {
			onload?.();
		} else if (existingScriptLink.hasAttribute('data-failed')) {
			onerror?.();
		} else {
			// Wait for it to load
			const checkLoaded = setInterval(() => {
				if (existingScriptLink.hasAttribute('data-loaded')) {
					clearInterval(checkLoaded);
					onload?.();
				} else if (existingScriptLink.hasAttribute('data-failed')) {
					clearInterval(checkLoaded);
					onerror?.();
				}
			}, 50);
		}
	} else {
		const script = document.createElement('script');
		script.src = src;
		script.async = false; // Load synchronously to ensure it's available before React renders
		script.id = id;
		script.onload = () => {
			script.setAttribute('data-loaded', 'true');
			onload?.();
		};
		// Third-party scripts get blocked (ad blockers, CSP, offline). Without this the caller
		// waits for an onload that never comes.
		script.onerror = () => {
			script.setAttribute('data-failed', 'true');
			onerror?.();
		};
		document.head.appendChild(script);
	}
}

export const loadStyleSheet = ({ href, id, onload }) => {
	const existingLink = document.querySelector('link[href="' + href + '"]');
	if (existingLink) {
		// If stylesheet already loaded and ready, call immediately
		if (existingLink.hasAttribute('data-loaded')) {
			onload?.();
		} else {
			// Wait for it to load
			const checkLoaded = setInterval(() => {
				if (existingLink.hasAttribute('data-loaded')) {
					clearInterval(checkLoaded);
					onload?.();
				}
			}, 50);
		}
	} else {
		const link = document.createElement('link');
		link.rel = 'stylesheet';
		link.href = href;
		link.id = id;
		link.onload = () => {
			link.setAttribute('data-loaded', 'true');
			onload?.();
		};
		document.head.appendChild(link);
	}
}